import { render } from "./Tooltip.vue?vue&type=template&id=34a6009c"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Tooltip.vue"]])

export default __exports__